import { makeStyles } from '@material-ui/core';
import { createStyles, Theme } from '@material-ui/core/styles';

import { colorsPalette, MIDDLE_MARGIN, SMALL_MARGIN } from '../../../../theme';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    wrapper: {
      flex: 1,
      minWidth: 290,
    },
    root: {
      marginBottom: MIDDLE_MARGIN,
    },
    indicator: {
      backgroundColor: `${colorsPalette.violet} !important`,
    },
    summaryWrapper: {
      marginBottom: MIDDLE_MARGIN,
    },
    summaryLoaderWrapper: {
      height: 300,
      position: 'relative',
    },
    mobileTab: {
      fontSize: 18,
      lineHeight: 1,
      fontWeight: 700,
    },
    tabText: {
      fontSize: 16,
      lineHeight: 1.5,
      color: colorsPalette.gray,
      '& h1,& h2,& h3,& h4,& h5,& h6,& p,& ul,& ol': {
        marginBottom: 18,
        marginTop: 0,
      },
      '& h1,& h2,& h3,& h4,& h5,& h6': {
        color: colorsPalette.white,
        lineHeight: 1.5,
      },
      '& ul, & ol': {
        paddingLeft: 20,
        '& li': {
          '&::marker': {
            color: colorsPalette.turquoiseLight,
          },
        },
      },
      '& svg g': {
        fill: colorsPalette.white,
        stroke: colorsPalette.white,
      },
      [theme.breakpoints.up('md')]: {
        fontSize: 18,
        marginBottom: MIDDLE_MARGIN,
      },
    },
    tabHeader: {
      fontSize: 24,
      lineHeight: 1,
      marginBottom: SMALL_MARGIN,
      fontWeight: 'bold',
      [theme.breakpoints.up('md')]: {
        fontSize: 26,
      },
    },
    list: {
      paddingLeft: 20,
    },
    listItem: {
      '&::marker': {
        color: colorsPalette.turquoiseLight,
      },
    },
    listText: {
      fontSize: 16,
      lineHeight: 1.5,
      color: colorsPalette.gray,
      [theme.breakpoints.up('md')]: {
        fontSize: 18,
      },
    },
    accordionRoot: {
      background: 'transparent',
      boxShadow: 'none',
      margin: 0,
      marginBottom: 18,
      '&:before': {
        display: 'none',
      },
    },
    accordionExpanded: {
      margin: '0 !important',
    },
    accordionSummary: {
      fontSize: 18,
      fontWeight: 'bold',
      color: colorsPalette.white,
      borderBottom: `2px solid ${colorsPalette.violetAnalyticsCard}`,
      padding: '10px 0',
      margin: 0,
      minHeight: 46,
    },
    accordionSummaryExpanded: {
      color: colorsPalette.white,
      margin: '0 !important',
      minHeight: 'unset !important',
    },
    accordionSummaryContent: {
      margin: 0,
      display: 'flex',
      alignItems: 'center',
    },
    accordionDetails: {
      padding: 0,
      paddingTop: 18,
    },
    accordionIconBlock: {
      marginRight: 13,
      marginLeft: 5,
      width: 14,
      height: 14,
      position: 'relative',
      '&::before': {
        display: 'block',
        content: '""',
        width: 14,
        height: 2,
        background: theme.palette.primary.light,
        marginTop: 6,
      },
      '&::after': {
        display: 'block',
        content: '""',
        width: 14,
        height: 2,
        background: theme.palette.primary.light,
        marginTop: -2,
        transform: 'rotate(-90deg)',
        transition: 'transform 150ms cubic-bezier(0.4, 0, 0.2, 1) 0ms',
      },
      '&.active::after': {
        transform: 'rotate(0deg)',
      },
    },
  }),
);

export default useStyles;
